import React from 'react';
export function HeaderLogo() {
  return <div className="flex items-center gap-4 flex-shrink-0" data-id="element-131">
      <a href="/" aria-label="Fenton Lakes Sportsman's Club Home" data-id="element-132">
        <img src="https://drwzpk38qkpfb.cloudfront.net/www.fentonlakes.com/uploaded/images/FentonLakes-logo.png" alt="Fenton Lakes Sportsman's Club" className="block h-20 md:h-24 w-auto object-contain" data-id="element-133" />
      </a>
      <div className="hidden xl:flex flex-col gap-0.5" data-id="element-134">
        <div className="flex items-start gap-1.5" data-id="element-135">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#c8a84b" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="flex-shrink-0 mt-0.5" data-id="element-136">
            <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" data-id="element-137" />
            <circle cx="12" cy="10" r="3" data-id="element-138" />
          </svg>
          <div data-id="element-139">
            <p style={{
            color: '#e8e4d8',
            fontFamily: 'Inter, sans-serif',
            fontSize: '13px',
            lineHeight: '1.4',
            fontWeight: 500
          }} data-id="element-140">
              1140 Butcher Rd
            </p>
            <p style={{
            color: '#a0b8a8',
            fontFamily: 'Inter, sans-serif',
            fontSize: '12px',
            lineHeight: '1.4'
          }} data-id="element-141">
              Fenton, MI 48430
            </p>
          </div>
        </div>
      </div>
    </div>;
}